import React, { Fragment } from 'react'
import { Breadcrumbs } from '../../../../AbstractElements';
import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import ItemwiseReportView from './ItemwiseReportView'

const ItemwiseReport = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Report" title="ItemWise Report" mainTitle="ItemWise Report" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <ItemwiseReportView />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default ItemwiseReport